import React from 'react';
import Slider from 'react-slick';
import shortid from 'shortid';
import Slide from './ProjectSlide';
import SectionManager from '../../managers/SectionManager';
import { LeftArrowIcon, RightArrowIcon } from '../../managers/IconManager';

class ProjectSlider extends React.PureComponent {
  state = {
    slidesToShow: 0,
    breakpoint: 0,
    pageCount: 0,
    currentPage: 0,
  };

  constructor(props) {
    super(props);
    const { section } = this.props;
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.getCurrentPage = this.getCurrentPage.bind(this);
    this.canTapSlide = true;
    this.currentSlide = 0;

    if (section) {
      this.section = new SectionManager(section);
      this.projects = this.section.getProjects();
    }
    this.customClasses = {
      dot: { normal: 'project_slider__dot', active: 'project_slider__dot--active' },
    };
    this.responsive = [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ];

    this.settings = {
      onSwipe: () => {
        this.canTapSlide = false;
      },
      dots: false,
      lazyLoad: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      onReInit: () => {
        if (this.slider) {
          const sliderBreakpoint = this.slider.state.breakpoint;
          const currentBreakpoint = sliderBreakpoint || 1024;
          const { breakpoint } = this.state;
          if (breakpoint !== currentBreakpoint) {
            const pageCount = this.getPageCount(currentBreakpoint);
            this.setState({
              breakpoint: currentBreakpoint,
              slidesToShow: this.getSlidesToShow(currentBreakpoint),
              pageCount,
            });
          }
        }
      },
      responsive: this.responsive,
      beforeChange: (_, next) => {
        const currentPage = this.getCurrentPage(next);
        this.setState({
          currentPage,
        });
        this.currentSlide = next;
      },
    };
  }

  getSlidesToShow = (breakpoint) => {
    for (let i = 0; i < this.responsive.length; i += 1) {
      const response = this.responsive[i];
      if (response.breakpoint === breakpoint) {
        return response.settings.slidesToShow;
      }
    }
    return 0;
  };

  getPageCount = (breakpoint) => {
    for (let i = 0; i < this.responsive.length; i += 1) {
      const response = this.responsive[i];
      if (response.breakpoint === breakpoint) {
        return Math.ceil(this.projects.length / response.settings.slidesToShow);
      }
    }
    return 0;
  };

  getCurrentPage = (currentSlide, log = false) => {
    const { pageCount } = this.state;
    const current = currentSlide || 0;
    const page = Math.floor((current / this.projects.length) * pageCount) || 0;
    if (log) {
      console.log(`currentSlide: ${currentSlide}, page: ${page}, pageCount: ${pageCount}, `);
    }
    return page;
  };

  next() {
    this.slider.slickNext();
  }

  previous() {
    this.slider.slickPrev();
  }

  dotClicked(target, dontAnimate = false) {
    this.slider.slickGoTo(target, dontAnimate);
  }

  createDot(i) {
    const { currentPage } = this.state;
    const { normal, active } = this.customClasses.dot;
    const className = `${normal}${i === (currentPage || 0) ? ` ${active}` : ''}`;
    const { slidesToShow } = this.state;
    return (
      <button
        type="button"
        key={`dot-${shortid.generate()}`}
        onClick={() => this.dotClicked(i * slidesToShow)}
        className={className}
      />
    );
  }

  createDots(dotCount) {
    const dots = [];

    for (let i = 0; i < dotCount; i += 1) {
      dots.push(this.createDot(i));
    }
    return dots;
  }

  render() {
    const { pageCount } = this.state;
    return (
      <div>
        <div className="project_slider">
          <div className="font-title project_slider__title">{this.section.getTitle()}</div>
          <div className="project_slider__dots">{this.createDots(pageCount)}</div>
          <div>
            <button type="button" className="project_slider__button" onClick={this.previous}>
              {LeftArrowIcon('project_slider__icon')}
            </button>
            <button type="button" className="project_slider__button" onClick={this.next}>
              {RightArrowIcon('project_slider__icon')}
            </button>
          </div>
        </div>
        <Slider
          ref={(c) => {
            this.slider = c;
          }}
          {...this.settings}
        >
          {this.projects.map(project => (
            <Slide key={`slide-${shortid.generate()}`} project={project} slider={this} />
          ))}
        </Slider>
      </div>
    );
  }
}

export default ProjectSlider;



// WEBPACK FOOTER //
// ./src/components/Sliders/ProjectSlider.js